import "../css/Section.css";
import { AppLandingPage } from "./AppLandingPage";

const Home = (props) => {
  return <AppLandingPage />;
};

export default Home;
